import httpClient from "@common/http-client";

interface RawYouParkSearchResult {
  organizationName?: string;
  organizationId?: string;
  areaId?: string;
  areaName?: string;
  lots?: { id?: string; name?: string }[];
}

export interface YouParkSearchResult {
  organizationName: string;
  organizationId: string;
  areaId: string;
  areaName: string;
  lots: { id: string; name: string }[];
}

const normalizeResult = (raw: RawYouParkSearchResult): YouParkSearchResult => {
  const organizationId = raw.organizationId ? String(raw.organizationId).trim() : "";
  const areaId = raw.areaId ? String(raw.areaId).trim() : "";
  const organizationName = (raw.organizationName ?? "").trim();
  const areaName = (raw.areaName ?? "").trim();

  const normalizedLots = (raw.lots ?? [])
    .map(lot => {
      const id = lot?.id ? String(lot.id).trim() : "";
      const name = (lot?.name ?? "").trim();
      const resolvedName = name.length > 0 ? name : id;
      const resolvedId = id.length > 0 ? id : resolvedName;
      return resolvedName.length > 0 ? { id: resolvedId, name: resolvedName } : null;
    })
    .filter((lot): lot is { id: string; name: string } => lot !== null);

  return {
    organizationName: organizationName.length > 0 ? organizationName : organizationId,
    organizationId,
    areaId,
    areaName,
    lots: normalizedLots
  };
};

export const searchService = {
  async searchYouPark(query: string): Promise<YouParkSearchResult[]> {
    const trimmed = query.trim();
    if (trimmed.length < 2) {
      return [];
    }

    const response = await httpClient.getUnwrapped<RawYouParkSearchResult[]>("/search/searchlots", {
      query: trimmed
    });

    return response.map(normalizeResult);
  }
};
